import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Page from 'src/components/Page'
import ProfessionalCourseCard from './ProfessionalCourseCard'
// import ProfessionalCourse from './ProfessionalCourse'
import Basket from './Basket'
import BoughtCourseDetails from '../boughtCourse/BoughtCourseDetails'
import BoughtCourseSection from '../boughtCourse/BoughtCourseSection'
import BoughtEpisodeVideos from '../boughtCourse/BoughtEpisodeVideos'

function PrivateCourses({ admin }) {
  return (
    <Page title="دوره های تخصصی">

      <Routes>
        <Route path="/" element={<ProfessionalCourseCard admin={admin} />} />
        {/* <Route path="/course/:id" element={<ProfessionalCourse />} /> */}
        <Route path="/course/:id" element={<BoughtCourseDetails professional admin={admin} />} />
        <Route path="/course/:id/section/:id" element={<BoughtCourseSection admin={admin} />} />
        <Route path="/course/:id/section/:id/episode/:id" element={<BoughtEpisodeVideos admin={admin} />} />
        <Route path="/basket" element={<Basket />} />
      </Routes>
    </Page>
  )
}

export default PrivateCourses
